import { createFileRoute } from "@tanstack/react-router";

import NotFound from "../pages/desktop/NotFound";
import { RoutePage, findRouteEntry } from "./routeTable";

export const Route = createFileRoute("/login")({
  head: () => ({
    meta: [
      { title: "Sign in — LevelLoad" },
      { name: "description", content: "Sign in — LevelLoad transport planning." },
      { property: "og:title", content: "Sign in — LevelLoad" },
      { property: "og:description", content: "Sign in — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  // `/login` is always in the route table since F-D3; the guard only covers a route table
  // without it.
  const entry = findRouteEntry("/login");
  if (!entry) return <NotFound />;
  return <RoutePage entry={entry} />;
}
